import { render, staticRenderFns } from "./CopTemplateView.vue?vue&type=template&id=23375404"
import script from "./CopTemplateView.vue?vue&type=script&lang=js"
export * from "./CopTemplateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports